export enum TransactionStatus {
  Init = 'init',
  Pending = 'pending',
  Rejected = 'rejected',
  Success = 'success'
}

export enum TransactionReason {
  AllowanceGTEAmountOfWbkn = 'AllowanceGTEAmountOfWbkn'
}

export type Transaction = {
  txHash: string;
  status: TransactionStatus;
  reason?: TransactionReason;
  finishStateSaved?: boolean;
};
